<template>
    <players v-if="network" :network="network" />
</template>
<script>
import { mapState } from 'vuex'
import api from '@/services/api'
import Players from './players/Index.vue'
export default {
  components: {
    Players,
  },
  data: () => ({
    network: null,
  }),
  computed: {
    ...mapState('app', ['locale', 'playersWorkspace']),
    workspaceID() {
      return this.playersWorkspace
    },
  },
  mounted () {
    this.handleGetNetwork()
  },
  methods: {
    handleGetNetwork () {
      this.network = null
      if (!this.workspaceID) return
      api.getItem('players', `v1/private/workspaces/`, `${this.workspaceID}/network`)
        .then(response => {
          this.network = response
        })
        .catch(error => {
          console.log(error)
        })
    },
  }
}
</script>
